'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { setSessionStoragePreviousUrl } from '../utils/sessionStoragePreviousUrl'

export const StorePreviousUrl = () => {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const searchString = searchParams?.toString()

	useEffect(() => {
		if (!pathname?.includes('/login')) {
			const currentUrl = searchString ? `${pathname}?${searchString}` : pathname
			setSessionStoragePreviousUrl(currentUrl)
		}
	}, [pathname, searchString])

	return null
}
